var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"app-toast",class:{'info': _vm.type=== 'info','success': _vm.type=== 'success','wraning': _vm.type=== 'wraning','danger': _vm.type=== 'danger'}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }